<div mat-dialog-title class="d-flex justify-content-between">
  <h5 class="mt-2">
    {{ isRemoving ? "Remover" : active ? "Desativar" : "Ativar" }}
  </h5>

  <a
    class="cursor-pointer decoration-none float-end text-dark"
    (click)="cancelar()"
    matTooltip="Fechar"
    [matTooltipPosition]="'after'"
  >
    <i class="far fa-times mt-3"></i>
  </a>
</div>

<div mat-dialog-content>
  <p>
    Você realmente deseja
    {{ isRemoving ? "remover" : active ? "desativar" : "ativar" }}
    <strong>{{ data }}</strong
    >?
  </p>
  @if (haveDescription) {
    <p style="color: red">
      <strong>{{ description }}</strong>
    </p>
  }
</div>

<div mat-dialog-actions class="d-flex justify-content-between">
  <button mat-stroked-button type="button" [mat-dialog-close] tabindex="-1">
    <i class="fas fa-ban me-2"></i>Não
  </button>

  <button
    mat-flat-button
    type="submit"
    color="primary"
    [mat-dialog-close]="true"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <i class="fas fa-check me-2"></i>Sim
  </button>
</div>
